<script>
	import { onMount } from 'svelte';
  import { mdiCheck } from '@mdi/js';
  import GoogleTagManagerService from '../services/tag-manager';
  import LineruTagsService from '../services/lineru-tags';

  let code = ""
  let message =""

  onMount(() => {
    const res  = window.location.search;

		const urlParams = new URLSearchParams(res);

    code = urlParams.get('referral_code');

    message = `¿Ya conocen Lineru? 🤔  Es un crédito por internet, perfecto para conseguir dinero rápido. Acá les dejo mi código de referido: ${code} 👌 . Aplicando con él en www.lineru.com, les dan 25% de descuento en intereses, administración y seguro en su primer crédito. ¡Recomendado! 🔥`
  })

  let current = 'btnSend';
  current = false;

  function copyText() {
    const message = document.getElementById('text').innerText;
    const el = document.createElement('textarea');
    el.value = message;
    // el.setAttribute('readonly', '');
    // el.style.position = 'absolute';
    // el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);

    current = 'btnSend';

    GoogleTagManagerService.setTag(LineruTagsService.general().copyCode);
    setTimeout(() =>{
      current = false;
    }, 3000);
  }
</script>

<div class="pt-lg-10 mb-10 mb-lg-0">
  <div class="container">
    <div class="d-grid grid-12">
      <div class="col-12 col-lg-6 d-none d-lg-block">
        <div>
          <img src="images/fold-3/models-2.png" alt="models">
        </div>
      </div>
      <div class="col-12 col-lg-6 px-lg-14 pt-lg-16">
        <div class="p-absolute">
          <img class="p-relative img_3" src="images/fold-3/forma-3.png" alt="" />
        </div>
        <h4 class="mb-8">Opción 2</h4>
        <h2 class="mb-8">Cópialo y pégalo donde quieras</h2>
        <p class="mb-10">Lleva <strong>tu código</strong> al muro o al chat que elijas y cuéntale a tus conocidos.</p>
        <div class="d-grid grid-12 gap-3">
          <div class="col-12 col-lg-5">
            <div class="brd-dashed t-center">
              <h3 class="pt-1 mb-1">
                {code}
              </h3>
              <p class="d-none" id="text">{message}</p>
            </div>
          </div>
          <div class="col-12 col-lg-7">
            <button
              id="btn"
              class="btn btn--shadow bgr-primary-500 bgr-brand-2:active t-white btn-lg mb-6 w-100 w-lg-auto d-flex t-left align-items-center t-center"
              role="button"
              aria-labelledby=""
              class:selected="{current === 'btnSend'}"
              on:click="{copyText}"
              >
              {#if current === 'btnSend'}
              <span class="flex-grow">
                  Código copiado
              </span>
              <svg class="w-5 h-auto -mr-3 t-black -mb-1" height="100%" viewBox="0 0 24 24">
                <path fill="currentColor" d={mdiCheck} />
              </svg>
              {:else}
              <span class="flex-grow">
                Copiar código
              </span>
              <svg
              class="ml-3 -mr-3 t-yellow"
              width="16"
              height="11">
              <path
                fill="currentColor"
                d="M15.902 5.257l-5-5.156a.326.326 0 00-.471 0 .351.351 0 000 .486l4.431 4.57H.333A.338.338 0 000 5.5c0 .19.15.344.333.344h14.529l-4.431 4.57a.351.351 0 000 .485.327.327 0 00.471 0l5-5.156a.351.351 0 000-.486z"></path>
              </svg>
              {/if}
              <span class="d-none qwerty"></span>
            </button>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  .brd-dashed {
    border: dashed #000000 2px;
  }
  .selected{
    background-color: #15DDA2;
    color: #000000;
  }
  .p-relative {
    position: relative;
  }
  .p-absolute {
    position: absolute;
  }
  .img_3 {
    left: 350px;
    bottom: 80px;
  }
  @media screen and (max-width: 568px){
    .img_3{
      background-size: auto;
      bottom: 40px;
      left: 210px;
    }
  }
</style>
